import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

const PendingVendor = () => {
  const context = useOutletContext();
  return (
    <Outlet context={context}/>
  )
}

export default PendingVendor